export default "__VITE_ASSET__6c7184b8__"